import { ReactNode, useState, useCallback, useEffect, ChangeEvent, MouseEvent, forwardRef, ReactElement, isValidElement } from 'react'
import cn from 'classnames/bind'

import PlainButton from 'app/common/ui-next/plain-button'
import IconLightCross from 'app/common/icons/IconLightCross'

import { path } from 'ramda'
import styles from './page-template-filter.module.scss';


const cx = cn.bind(styles)

type Props = {
  className?: string
  contentClassName?: string
  onApplyFilter: (e: ChangeEvent<HTMLFormElement>) => void
  onClose?: (e: MouseEvent<HTMLElement>) => void
  onResetAll: () => void
  loading?: boolean
  // eslint-disable-next-line react/no-unused-prop-types
  arrowClassName?: string // depracated, use bottomFilterArrowDecoration in PageTemplateContent
  // eslint-disable-next-line react/no-unused-prop-types
  arrowLeftShift?: number // deprecated, use bottomFilterArrowDecorationShift in PageTemplateContent
  // eslint-disable-next-line react/no-unused-prop-types
  arrowHide?: boolean
  wideOrientation?: boolean
  wide?: boolean
  readyApplyFilterBtn?: boolean
  children: ReactNode | ((resetStatus: boolean) => ReactNode)
}

const PageTemplateFilter = forwardRef<HTMLDivElement, Props>(({
  className,
  contentClassName,
  onApplyFilter,
  onClose,
  onResetAll,
  loading,
  wideOrientation,
  wide,
  readyApplyFilterBtn = true,
  children,
}, ref) => {
  const [resetStatus, setResetStatus] = useState(false)

  const handleResetAll = useCallback((e) => {
    e.preventDefault()
    setResetStatus(true)
    if (typeof onResetAll === 'function') {
      onResetAll()
    }
  }, [onResetAll])

  const handleSubmitFilter = useCallback((e: ChangeEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (e.target.id !== 'filter') return
    onApplyFilter(e)
  }, [onApplyFilter])

  useEffect(() => {
    if (resetStatus) {
      setResetStatus(false)
    }
  }, [resetStatus])

  const buttons = (
    <>
      <PlainButton
        onClick={handleResetAll}
        className={styles.outlineBt}
        outline
      >
        {'Сбросить все фильтры'}
      </PlainButton>
      <PlainButton disabled={loading || !readyApplyFilterBtn} type="submit">
        {'Применить'}
      </PlainButton>
    </>
  )

  return (
    <div className={cx(styles.root, className)} ref={ref}>

      <form onSubmit={handleSubmitFilter} id="filter">
        <div className={styles.filterContainer}>

          <div className={cx(styles.filterContainerMain, { wideOrientation, wide })}>
            <button onClick={onClose} className={styles.close} type="button" aria-label="Закрыть">
              <IconLightCross />
            </button>
            <div className={cx(styles.content, contentClassName)}>
              {typeof children === 'function'
                ? children(resetStatus)
                : children}
            </div>
            {wideOrientation
              && <div className={styles.submitButtonsWideOrientation}>{buttons}</div>}
          </div>

          {!wideOrientation
            && <div className={styles.submitButtons}>
              {buttons}
            </div>}
        </div>
      </form>
    </div>
  )
})

type ColumnProps = {
  children: ReactNode
  className?: string
}
const Column = ({ children, className }: ColumnProps) => (
  <div className={cx(styles.col, className)}>
    {children}
  </div>
)

const PageTemplateFilterNamespace = Object.assign(PageTemplateFilter, { Column, displayName: 'PageTemplateFilter' })
export { PageTemplateFilterNamespace as PageTemplateFilter }

export const isPageTemplateFilter = (
  comp: ReactNode,
): comp is ReactElement<Props, typeof PageTemplateFilter> => {
  const displayName = path(['type', 'displayName'], comp)
  return isValidElement(comp) && displayName === 'PageTemplateFilter'
}
